import { render } from "./PlanosPagamento.vue?vue&type=template&id=1fe8c5d4"
import script from "./PlanosPagamento.vue?vue&type=script&lang=js"
export * from "./PlanosPagamento.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__